import type { ClassValue } from "svelte/elements";
import { ButtonVariant } from "../../../../core/schema/ButtonVariant.js";
import { tw } from "@core/utils/svelte/tw.js";

const commonClass = tw("md:rounded-xl rounded-lg text-2xs/[1.2] md:text-base/none uppercase tracking-[0.025em]");
const paddingClass = tw("px-2.5 py-1 md:px-4 md:py-2");

export function getButtonClass(variant: ButtonVariant): ClassValue {
	switch (variant) {
		case ButtonVariant.Primary:
			return tw(
				commonClass,
				paddingClass,
				"font-semibold text-white bg-cmcprimary disabled:text-cmcmidgray disabled:bg-cmclightgray hover:bg-[#008ABD] transition-all duration-300",
			);
		case ButtonVariant.Text:
			return tw(commonClass, " font-bold text-cmcsecondary");
		case ButtonVariant.Outlined:
			return tw(
				commonClass,
				paddingClass,
				"font-semibold text-cmcsecondary border-2 border-current !py-[calc(0.25rem-2px)] md:!py-[calc(0.5rem-2px)]",
			);
	}
}
